/**
 * @generated SignedSource<<7865bfe8485d8a582ad5d6bad326daa4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AssetType = "LAYER_1" | "NATIVE" | "SECURED" | "SYNTH" | "%future added value";
export type Chain = "AVAX" | "BASE" | "BCH" | "BSC" | "BTC" | "DOGE" | "ETH" | "GAIA" | "KUJI" | "LTC" | "NOBLE" | "OSMO" | "SOL" | "TERRA" | "TERRA2" | "THOR" | "TON" | "TRON" | "TRON" | "XRP" | "%future added value";
export type HomeAutomatedOpportunityQuery$variables = {
  minInvestmentAgeDays: number;
  minValueUsd: bigint;
};
export type HomeAutomatedOpportunityQuery$data = {
  readonly finV3: {
    readonly ranges: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly analytics: {
            readonly apr: bigint;
          } | null | undefined;
          readonly id: string;
          readonly pair: {
            readonly assetBase: {
              readonly asset: string;
              readonly chain: Chain;
              readonly metadata: {
                readonly symbol: string;
              };
              readonly type: AssetType;
            };
            readonly assetQuote: {
              readonly asset: string;
              readonly chain: Chain;
              readonly metadata: {
                readonly symbol: string;
              };
              readonly type: AssetType;
            };
          };
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  };
};
export type HomeAutomatedOpportunityQuery = {
  response: HomeAutomatedOpportunityQuery$data;
  variables: HomeAutomatedOpportunityQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "minInvestmentAgeDays"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "minValueUsd"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 25
  },
  {
    "kind": "Variable",
    "name": "minInvestmentAgeDays",
    "variableName": "minInvestmentAgeDays"
  },
  {
    "kind": "Variable",
    "name": "minValueUsd",
    "variableName": "minValueUsd"
  },
  {
    "kind": "Literal",
    "name": "sortBy",
    "value": "APR"
  },
  {
    "kind": "Literal",
    "name": "sortDir",
    "value": "DESC"
  },
  {
    "kind": "Literal",
    "name": "status",
    "value": "OPEN"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "apr",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "asset",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "chain",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Metadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "symbol",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = [
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/)
],
v9 = [
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HomeAutomatedOpportunityQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FinV3",
        "kind": "LinkedField",
        "name": "finV3",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "FinRangeConnection",
            "kind": "LinkedField",
            "name": "ranges",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FinRangeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FinRange",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FinRangePositionAnalytics",
                        "kind": "LinkedField",
                        "name": "analytics",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FinPair",
                        "kind": "LinkedField",
                        "name": "pair",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Asset",
                            "kind": "LinkedField",
                            "name": "assetBase",
                            "plural": false,
                            "selections": (v8/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Asset",
                            "kind": "LinkedField",
                            "name": "assetQuote",
                            "plural": false,
                            "selections": (v8/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HomeAutomatedOpportunityQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FinV3",
        "kind": "LinkedField",
        "name": "finV3",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "FinRangeConnection",
            "kind": "LinkedField",
            "name": "ranges",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FinRangeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FinRange",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FinRangePositionAnalytics",
                        "kind": "LinkedField",
                        "name": "analytics",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FinPair",
                        "kind": "LinkedField",
                        "name": "pair",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Asset",
                            "kind": "LinkedField",
                            "name": "assetBase",
                            "plural": false,
                            "selections": (v9/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Asset",
                            "kind": "LinkedField",
                            "name": "assetQuote",
                            "plural": false,
                            "selections": (v9/*: any*/),
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "75857ad50f17a7d3bccd5afd5336a68c",
    "id": null,
    "metadata": {},
    "name": "HomeAutomatedOpportunityQuery",
    "operationKind": "query",
    "text": "query HomeAutomatedOpportunityQuery(\n  $minInvestmentAgeDays: Int!\n  $minValueUsd: Bigint!\n) {\n  finV3 {\n    ranges(first: 25, status: OPEN, sortBy: APR, sortDir: DESC, minInvestmentAgeDays: $minInvestmentAgeDays, minValueUsd: $minValueUsd) {\n      edges {\n        node {\n          id\n          analytics {\n            apr\n            id\n          }\n          pair {\n            assetBase {\n              asset\n              type\n              chain\n              metadata {\n                symbol\n              }\n              id\n            }\n            assetQuote {\n              asset\n              type\n              chain\n              metadata {\n                symbol\n              }\n              id\n            }\n            id\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "12c23a29cc32831c8d99bc2eea1270d7";

export default node;
